import { combineEpics, ofType } from "redux-observable"
import { map, flatMap, tap, filter } from "rxjs/operators"
import { of, from } from "rxjs"
import { Epic } from "../../epics"
import env from "../../env"

import * as actions from "./actions"

export const initializeSearchEpic: Epic = (action$, state$, _dependencies$) =>
    action$.pipe(
        ofType(actions.INITIALIZE),
        filter(() => {
            const {
                search: { isInitialized },
            } = state$.value
            return !isInitialized
        }),
        flatMap(() => {
            return of(actions.setInitialized())
        }),
    )

export const searchEpic: Epic = (
    action$,
    _state$,
    { search: { searchAPI, windowOpen } },
) =>
    action$.pipe(
        ofType(actions.REQUEST_SEARCH),
        flatMap((action: actions.RequestSearch) =>
            from(searchAPI.search(action.searchString)),
        ),
        map((result: string) =>
            actions.receiveSearchResults(`${env.applicationPath}${result}`),
        ),
        tap((action: actions.ReceiveSearchResults) =>
            windowOpen(action.searchResultsUrl, "_self"),
        ),
    )

export default combineEpics(initializeSearchEpic, searchEpic)
